export default {
  transparent: 'rgba(0,0,0,0.75)',
  //Example colors:
  text: '#fff',
  primary: '#d15531'
  //   success: '#28a745',
  //   error: '#dc3545'
};
